import { CommonDataServiceEntityDataset } from 'app/model/dataset/common-data-service.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.commonDataService.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(CommonDataServiceEntityDataset) }
})
export class CommonDataServiceCopySource extends TabularCopySource {
}
